import React from 'react';
import { ArrowLeft } from 'lucide-react';

/**
 * Consistent back-navigation bar for all SQAAF sub-pages.
 * Sits at the very top of the page content, full-width, with a subtle border.
 */
const BackNav = ({ onBack, label = 'Back to Dashboard', right = null }) => (
    <div className="flex items-center justify-between px-6 py-3 bg-white border-b border-gray-100 font-[Poppins]">
        <button
            onClick={onBack}
            className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-[#1D3469] transition-colors group cursor-pointer"
        >
            <span className="w-7 h-7 rounded-lg bg-gray-100 group-hover:bg-[#1D3469]/10 flex items-center justify-center transition-colors">
                <ArrowLeft className="w-3.5 h-3.5 text-gray-500 group-hover:text-[#1D3469] transition-colors" />
            </span>
            {label}
        </button>
        {right && <div>{right}</div>}
    </div>
);

export default BackNav;
